import React from 'react'

const MadeWithLove = (props) => {
    const heartStyle = {
        color: props.mode === 'dark' ? '#ff8c00' : 'red',
    };
    return (
        <>
            <div>
                Made with <span style={heartStyle} role="img" aria-label="Heart">❤️</span> in India by Pranav Arya
            </div>
        </>
    )
}

export default MadeWithLove
